import {
  MDSListBoxItem,
  MDSListBoxItemProps,
  MDSListBoxSlotName,
} from "@/mds/components/lists/list-box-item";
import {
  StyledHeader,
  StyledListBox,
  StyledLeftAddon,
  StyledRightAddon,
} from "@/mds/components/lists/list-box/list-box.style";
import { MDSListBoxProps } from "@/mds/components/lists/list-box/list-box.types";

export const MDSListBox = ({ items, label, children, ...props }: MDSListBoxProps) => {
  if (!items && children) {
    // static list box
    return (
      <>
        {label && <StyledHeader>{label}</StyledHeader>}
        <StyledListBox {...props} aria-label={label}>
          {children}
        </StyledListBox>
      </>
    );
  }

  // dynamic list box
  return (
    <>
      {label && <StyledHeader>{label}</StyledHeader>}
      <StyledListBox {...props} items={items as MDSListBoxItemProps[]} aria-label={label}>
        {item => (
          <MDSListBoxItem key={item.id} {...item}>
            <StyledLeftAddon slot={MDSListBoxSlotName.LeftAddon}>{item.leftAddon}</StyledLeftAddon>
            {item.children}
            <StyledRightAddon slot={MDSListBoxSlotName.RightAddon}>
              {item.rightAddon}
            </StyledRightAddon>
          </MDSListBoxItem>
        )}
      </StyledListBox>
    </>
  );
};
